import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { INDEX_PAGE } from './useInvoices'; // item 1480 — whole index, not a 100-row page
import { WorkOrder } from '../models/workOrder';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

interface WorkOrdersArchivedDto { index: WorkOrder[]; }

const getArchived = async (): Promise<WorkOrdersArchivedDto> => {
  const { data } = await axios.get(`${apiUrl}WorkOrder/IndexArchived`, { params: { pageSize: INDEX_PAGE } });
  return data;
};

// item 553 — archived work orders (mirrors useProposalsArchived): archive moves a WO OUT of
// the main list; restore brings it back. Restore is moderator-gated server-side.
const useWorkOrdersArchived = (enabled = true) => {
  const queryClient = useQueryClient();
  const query = useQuery('workOrdersArchived', getArchived, { enabled });

  const restoreMutation = useMutation(
    (id: string) => axios.post(`${apiUrl}WorkOrder/Restore/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('workOrdersArchived');
        queryClient.invalidateQueries('workOrders');
        queryClient.invalidateQueries('project');
      },
    },
  );

  return {
    archived: query.data?.index ?? [],
    isLoadingArchived: query.isLoading,
    restore: restoreMutation.mutateAsync,
    isRestoring: restoreMutation.isLoading,
  };
};

export default useWorkOrdersArchived;
